// «Первое письмо» (030: contracts/api.md, «Первое письмо»; data-model.md, `delivery.first_letters`;
// research Р5; ASG-ONB-05, ASG-ONB-10). Окно в протоколе показывает, кто получит письмо и кто нет
// с причиной, до отправки (принцип III); письма уходят в 08:00 следующего рабочего дня, отмена —
// до отправки; человек получает письмо по протоколу один раз (FR-017).
import { z } from '../kernel/zod.ts';
import { TimestampSchema } from '../kernel/common.ts';

/** Почему человек не получит письмо (FR-015): нет почты, адрес не подтверждён, вход только
 * с корпоративной почтой, компания без «получает письма». */
export const firstLetterSkipReasons = [
  'no_email',
  'not_confirmed',
  'corporate_only',
  'org_no_mail',
] as const;
export type FirstLetterSkipReason = (typeof firstLetterSkipReasons)[number];
export const FirstLetterSkipReasonSchema = z.enum(firstLetterSkipReasons);

export const firstLetterSkipLabels = {
  no_email: 'нет почты',
  not_confirmed: 'адрес не подтверждён',
  corporate_only: 'вход только с корпоративной почтой',
  org_no_mail: 'компания без «получает письма»',
} as const satisfies Record<FirstLetterSkipReason, string>;

/** Кто подключил — роль без ФИО («Первое письмо», FR-013). */
/** Кто запланировал (040): администратор или владелец протокола; controller перевела миграция 0012. */
export const firstLetterRoles = ['lead', 'client_admin'] as const;
export type FirstLetterRole = (typeof firstLetterRoles)[number];
export const FirstLetterRoleSchema = z.enum(firstLetterRoles);

/** Состояние строки `delivery.first_letters`. */
export const firstLetterStates = ['scheduled', 'sent', 'cancelled', 'skipped'] as const;
export type FirstLetterState = (typeof firstLetterStates)[number];

/**
 * GET/POST/DELETE /api/protocols/{id}/first-letter. runAt — ближайшие 08:00 следующего рабочего
 * дня (firstLetter.hour, пояс установки); recipients — получат сейчас; copies — копии основным
 * кураторам внешних; already — уже получили по этому протоколу; scheduled — запланированная
 * отправка, которую можно отменить.
 */
export const FirstLetterViewSchema = z.object({
  runAt: TimestampSchema,
  recipients: z.number().int().min(0),
  copies: z.number().int().min(0),
  already: z.number().int().min(0),
  skipped: z.array(z.object({ name: z.string(), reason: FirstLetterSkipReasonSchema })),
  scheduled: z
    .object({
      runAt: TimestampSchema,
      count: z.number().int().min(0),
      by: FirstLetterRoleSchema,
    })
    .nullable(),
  /**
   * 033 (FR-003, FR-005): установка в песочнице — из total получателей окна письмо уйдёт inList,
   * остальным — тень; боевой режим — null.
   */
  sandbox: z.object({ inList: z.number().int().min(0), total: z.number().int().min(0) }).nullable(),
});
export type FirstLetterView = z.infer<typeof FirstLetterViewSchema>;
